export default (value, obj) => {
    const descriptionLength = obj.uploader_fileDescription?.length ?? 0;

    return descriptionLength <= 2048;
};
